import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";
// import Cookies from "js-cookie";

const store = createStore({
  state: {
    token: "",
    loginUser: {
      userNameFirst: "",
      userNameLast: "",
      userNameFirstKana: "",
      userNameLastKana: "",
      affiliation: "",
      contactPhone: "",
      mailAddress: "",
      firstPwdChngFlg: "",
      authenticationFailNum: Number,
      accountLockFlg: "",
      accountLockReleaseTime: "",
      pwdExpiredFlg: "",
      userRole: "",
    },
  },
  mutations: {
    saveToken(state, token) {
      state.token = token
    },
    removeToken(state) {
      state.token = ""
    },
    saveLoginUser(state, loginUser) {
      state.loginUser = loginUser
    },
  },
  actions: {
    saveToken({ commit }, token) {
      commit("saveToken", token)
    },
    removeToken({ commit }) {
      commit("removeToken")
    },
    saveLoginUser({ commit }, loginUser) {
      commit("saveLoginUser", loginUser)
    },
  },
  modules: {},
  getters: {
    getToken(state) {
      return state.token
    },
    getLoginUser(state){
      return state.loginUser
    },
  },
  plugins: [createPersistedState(
    { // ストレージのキーを指定。デフォルトではvuex
      key: 'anyGreatApp',

      // 管理対象のステートを指定。pathsを書かない時は`modules`に書いたモジュールに含まれるステート全て。`[]`の時はどれも保存されない
      paths: [
        'token',
        'loginUser',
      ],

      // ストレージの種類を指定する。デフォルトではローカルストレージ
      // storage: window.localStrage,
      storage: window.sessionStorage,
      // storage: {
      //   getItem: (key) => Cookies.get(key),
      //   // Please see https://github.com/js-cookie/js-cookie#json, on how to handle JSON.
      //   setItem: (key, value) =>
      //     Cookies.set(key, value, { expires: 3, secure: true }),
      //   removeItem: (key) => Cookies.remove(key),
      // },
    }
  )],
})

export default store